import type {
  LabelTemplate,
  LabelTemplateType,
} from '@/api/hooks/useLabelTemplates';

/**
 * What actually resolves for (type, warehouse) — the FE mirror of
 * `LabelTemplateResolverService.resolve`: a warehouse-scoped default beats a
 * global one; an inactive default never resolves; no default means the
 * screen's built-in layout.
 *
 * The ONLY client-side copy of the precedence rule — the Where-labels-print
 * card and the print dialog's preselect both call this, so a rule change is
 * one edit here plus the server.
 */
export function resolveSiteDefault(
  templates: LabelTemplate[] | undefined,
  type: LabelTemplateType,
  warehouseId: string | null,
): LabelTemplate | null {
  const candidates = (templates ?? []).filter(
    (t) => t.type === type && t.isDefault && t.isActive,
  );
  return (
    candidates.find((t) => t.warehouseId === warehouseId) ??
    candidates.find((t) => t.warehouseId === null) ??
    null
  );
}
